import React from "react";
import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { useAppSelector } from "../../reduxStore/reduxHooks";
import { getConfigData } from "../../reduxStore/slices/configSlice";
import { StatusEnum } from "@amzn/hvh-simple-hire-checklist-internal-api-common";
import { useChecklistArb } from "../../hooks/use-arb";
import { IconExternalLink } from "@amzn/stencil-react-components/icons";

interface LetterOfIntentButtonProps {
  status: StatusEnum;
}

export const LetterOfIntentButton = ({ status }: LetterOfIntentButtonProps) => {
  const bundle = useChecklistArb();
  const { letterOfIntent } = useAppSelector(getConfigData);

  const buttonText = bundle.getMessage("Checklist-MainPage-Letter-Of-Intent-Title");

  return (
    <Button
      variant={ButtonVariant.Primary}
      disabled={!letterOfIntent?.loginUrl}
      onClick={() => window.open(letterOfIntent?.loginUrl)}
      data-testid="letter-of-intent-button"
    >
      {buttonText}
      <IconExternalLink />
    </Button>
  );
};
